import axios from "axios";
import ErrorParser from '../error.parser';

const CalculatedService = {
  networks: async function () {
    const requestData = {
      method: "get",
      url: "/api/processing/calculated/networks",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  calculated_timeseries: async function (net_id) {
    const requestData = {
      method: "post",
      url: "/api/processing/calculated/calculated_timeseries",
      data: {
        net_id: net_id
      }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      let message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  insert: async function (calculated_timeserie) {
    const requestData = {
      method: "post",
      url: "/api/processing/calculated/insert",
      data: calculated_timeserie
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },  
  update: async function (calculated_timeserie) {
    const requestData = {
      method: "post",
      url: "/api/processing/calculated/update",
      data: calculated_timeserie
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  delete: async function (id) {
    const requestData = {
      method: "post",
      url: "/api/processing/calculated/delete",
      data: { id: id }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }
};

export default CalculatedService;
